import type { FC } from "react";
import ImageContainer from "../../../general/ImageContainers/ImageContainer";
import Icon from "../../../general/Icon";
import * as s from "./ToasterItem.module.scss";

type ToasterItemProps = {
	name: string;
	price: string;
	color: string;
	fabric?: string;
	image?: { src: string; alt?: string | null };
	giftWrapMessage?: string;
};

const ToasterItem: FC<ToasterItemProps> = ({
	name,
	price,
	color,
	fabric,
	image,
	giftWrapMessage,
}) => {
	const variant = fabric ? `${color} / ${fabric}` : color;
	return (
		<div className={s.container}>
			<div className={s.productInfo}>
				<div className={s.label}>
					<p className={s.name}>{name}</p>
					<p className={s.variant}>{variant}</p>
					<label className={s.price}>{price}</label>
				</div>
				{giftWrapMessage && (
					<span className={s.giftWrap}>
						<Icon icon="gift" width={20} />
						<p>{giftWrapMessage}</p>
					</span>
				)}
			</div>
			{image?.src && (
				<ImageContainer
					className={s.image}
					imgSrc={image.src}
					alt={image.alt ?? ""}
				/>
			)}
		</div>
	);
};

export default ToasterItem;
